export const SET_KNOWLEDGEBASE = 'SET_KNOWLEDGEBASE';
export const SET_HELPBAR = 'SET_HELPBAR';
export const SET_DYNAMIC_CONTENT = 'SET_DYNAMIC_CONTENT';
export const SET_TERMS_CONDITIONS = 'SET_TERMS_CONDITIONS';
export const SET_LOADING_MESSAGE = 'SET_LOADING_MESSAGE';
export const CLEAR_LOADING_MESSAGE = 'CLEAR_LOADING_MESSAGE';
